export default "__VITE_ASSET__0b2fdf95__"